import React, { FC, useEffect, useLayoutEffect, useState } from 'react';
import { getShopInfosInStorage } from './ShopInfos';
import { Picto } from '@dp/website-components';
import { Surfaces } from './iCart';
import { Modal } from '@dp/product-customizer-components';
import { getHostApi } from '../../utils';
import { TranslationProps, WithTranslation } from '../../contexts/TranslationContext';

interface RenderPictoProps extends TranslationProps {
  item: any;
}

const RenderPicto: FC<RenderPictoProps> = (props): JSX.Element => {
  const [visuels, setVisuels] = useState<Record<string, string|undefined>>({});
  const [surfaceOpen, setSurfaceOpen] = useState<undefined|Surfaces>(undefined);
  const [pictoSize, setPictoSize] = useState<number>(200);

  useEffect(() => {
    setVisuels({});
    for (const surface of (props.item?.surfaces ?? [])) {
      getVisuel(surface.data_picto.surface_emplacement_id)
      .then((result) => {
        setVisuels((prevVisuels) => ({
          ...prevVisuels,
          [surface.data_picto.surface_emplacement_id]: result,
        }));
      });
    }
  }, [props.item]);

  useLayoutEffect(() => {
    const fnResize = () => {
      if (window.innerWidth < 576) {
        setPictoSize(window.innerWidth * 0.7);
      } else if (window.innerWidth < 768) {
        setPictoSize(300);
      } else if (window.innerWidth < 992) {
        setPictoSize(500);
      } else {
        setPictoSize(700);
      }
    };
    fnResize();
    window.addEventListener('resize', fnResize);
    return () => window.removeEventListener('resize', fnResize);
  }, [pictoSize]);

  const defineRatio = (nbSurfaces: number): number => {
    return nbSurfaces <= 2 ? 60 : 30;
  };

  const renderSurfaces = (): string => {
    const html: string[] = [];
    if (props.item.surfaces.length > 0) {
      props.item.surfaces.forEach((element: any, i: any) => {
        if (element.surface) {
          html.push(element.surface.surface.nom.charAt(0).toUpperCase() + element.surface.surface.nom.substr(1) + ' ' +
            element.surface.emplacement.nom);
        }
      });
    }

    return html.join(', ');
  };

  const getVisuel = async (surfaceEmplacementId: number): Promise<string|undefined> => {
    let result = undefined;
    const host = getShopInfosInStorage().Ref === 'TH' ? getHostApi() : '';
    if (props.item.with_uploaded_file === 1) {
      let tmpUrl = `${host}/upload-${shopInfos.Ref.toLocaleLowerCase()}/${props.item.creation_id}/miniatures/${props.item.creation_id}-${surfaceEmplacementId}.webp`;
      let response = await fetch(tmpUrl);
      if (response.status === 200) {
        result = tmpUrl;
      } else {
        tmpUrl = `${host}/upload-${shopInfos.Ref.toLocaleLowerCase()}/${props.item.creation_id}/miniatures/${props.item.creation_id}-${surfaceEmplacementId}.png`;
        response = await fetch(tmpUrl);
        if (response.status === 200) {
          result = tmpUrl;
        }
      }
    }
    return result;
  };

  const surfacesString = renderSurfaces();
  const shopInfos = getShopInfosInStorage();
  return (
    <>
      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 d-flex flex-column text-center">
      { props.item.marquage.id == 0 && <div>{ props.textsContent['CART_ITEM_NO_MARKING'] ?? 'Aucun' }</div>}
      {props.item.marquage.id != 0 && !['MT', 'ME'].includes(shopInfos.Ref) && (
        <>
          <div className="d-flex justify-content-between" style={{ marginTop: 4, marginBottom: 4 }}>
            {props.item.article.produit.picto.nom != 'indefini' && props.item.surfaces.map((surface: any) => {
              const visuel = visuels?.[surface.data_picto.surface_emplacement_id];
              return (
                <div
                  className={`mx-auto ${visuel ? 'cursor-pointer' : ''}`}
                  key={`picto-${props.item.id}-${surface.data_picto.surface_emplacement_id}`}
                  onClick={() => visuel && setSurfaceOpen(surface)}
                >
                  <Picto
                    srcImg={surface.data_picto.image}
                    size={defineRatio(props.item.surfaces.length)}
                    hexadecimal={`#${props.item.article.couleur.code1}`}
                    coordonnees={{
                      pictoId: parseInt(surface.data_picto.id),
                      surfaceEmplacementId: parseInt(surface.data_picto.surface_emplacement_id),
                      paysage_x: parseFloat(surface.data_picto.paysage_x),
                      paysage_y: parseFloat(surface.data_picto.paysage_y),
                      portrait_x: parseFloat(surface.data_picto.portrait_x),
                      portrait_y: parseFloat(surface.data_picto.portrait_y),
                      x: parseFloat(surface.data_picto.x),
                      x_web: parseFloat(surface.data_picto.x_web),
                      y: parseFloat(surface.data_picto.y),
                      y_web: parseFloat(surface.data_picto.y_web),
                      visuel: visuels?.[surface.data_picto.surface_emplacement_id],
                    }}
                  />
                </div>
              );
            })}
          </div>
          {surfacesString.length > 0 && (
            <div className="font11 d-none d-lg-block">
              <p className="m-0 p-0"><span className="bold">Surfaces : </span>{renderSurfaces()}</p>
              <p className="m-0 p-0"><span className="bold">Marquage : </span>{props.item.marquage.libelle}</p>
            </div>
          )}
        </>
      )}
      </div>
      <Modal
        show={surfaceOpen !== undefined}
        borderRadius="4px"
        onClose={() => setSurfaceOpen(undefined)}
      >
        {surfaceOpen && (
          <>
            <Picto
              srcImg={surfaceOpen.data_picto.image_large}
              size={pictoSize}
              hexadecimal={`#${props.item.article.couleur.code1}`}
              coordonnees={{
                pictoId: parseInt(surfaceOpen.data_picto.id),
                surfaceEmplacementId: parseInt(surfaceOpen.data_picto.surface_emplacement_id),
                paysage_x: parseFloat(surfaceOpen.data_picto.paysage_x),
                paysage_y: parseFloat(surfaceOpen.data_picto.paysage_y),
                portrait_x: parseFloat(surfaceOpen.data_picto.portrait_x),
                portrait_y: parseFloat(surfaceOpen.data_picto.portrait_y),
                x: parseFloat(surfaceOpen.data_picto.x),
                x_web: parseFloat(surfaceOpen.data_picto.x_web),
                y: parseFloat(surfaceOpen.data_picto.y),
                y_web: parseFloat(surfaceOpen.data_picto.y_web),
                visuel: visuels?.[surfaceOpen.data_picto.surface_emplacement_id],
              }}
            />
            <div className="font20 bold mt1 mt-1 text-center text-capitalize">{surfaceOpen.surface.surface.nom} {surfaceOpen.surface.emplacement.nom}</div>
          </>
        )}
      </Modal>
    </>
  )
};

export default WithTranslation<RenderPictoProps>(RenderPicto, 'CART_TUNNEL');
